import {
    documentOptions,
    languageOptions,
    preliminaryOptions,
    terminationOptions,
    violationOptions,
} from '@gov.wa.lni/application.child-labor-complaint/source/data/options';

export default {
    namespaced: 'true',
    state     : {
        complaintNumber: '',
        formData       : {
            complaint  : {},
            documents  : [],
            employee   : {},
            contact    : {},
            attestation: false,
        },
        text: {},
    },
    getters: {
        complaintNumber     : state => state.complaintNumber,
        documentOptions     : state => documentOptions(state.text),
        formData            : state => state.formData,
        forMultipleMinors   : state => Object.hasOwn(state.formData.complaint, 'complainant') ? state.formData.complaint.complainant === state.text.multipleMinors : false,
        forSelf             : state => Object.hasOwn(state.formData.complaint, 'complainant') ? state.formData.complaint.complainant === state.text.me : false,
        languageOptions     : state => languageOptions(state.text),
        preliminaryOptions  : state => preliminaryOptions(state.text),
        selectedOption      : (state, getters) => (options, value) => getters[options].find(opt => opt.value === value),
        selectedOptionByText: (state, getters) => (options, value) => getters[options].find(opt => opt.text === value),
        terminationOptions  : state => terminationOptions(state.text),
        text                : state => state.text,
        violationOptions    : state => violationOptions(state.text),
    },
    mutations: {
        SET_DOCUMENTS(state, payload) {
            state.formData.documents = payload;
        },
        SET_VALUE(state, payload) {
            state[payload.key] = payload.value;
        },
        UPDATE_DATA(state, payload) {
            state.formData[payload.key] = payload.value;
        },
    },
};